import { Button, Stack } from "@mui/material";

import { useDisclosure } from "hooks";

import { LatestSupplierShipmentRoutePointETADisplay } from "../LatestSupplierShipmentRoutePointETADisplay";
import { SupplierShipmentStateDisplay } from "../SupplierShipmentStateDisplay";
import { SupplierShipmentStatusHistoryTable } from "../SupplierShipmentStatusHistoryTable";

interface Props {
  dividerComponent: JSX.Element;
  shipment: SupplierShipment;
}

export function SupplierShipmentStatusSection(props: Props) {
  const { dividerComponent, shipment } = props;
  const {
    isOpen: historyOpen,
    onClose: onCloseHistory,
    onOpen: onOpenHistory,
  } = useDisclosure(false);

  if (
    !shipment ||
    shipment.shipment_status === "ACTIVE" ||
    shipment.shipment_status === "CANCELLED" ||
    shipment?.info?.booked_at == null ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT"
  ) {
    return null;
  }

  return (
    <Stack mb="1.5rem">
      {dividerComponent}
      <Stack direction="column" spacing={1}>
        <SupplierShipmentStateDisplay shipment={shipment} />
        <LatestSupplierShipmentRoutePointETADisplay shipment={shipment} />
      </Stack>
      <Stack id="button-container" sx={{ pt: "1rem" }} direction="row">
        <Stack width="100%" direction="row" justifyContent="right">
          <Button
            variant="text"
            onClick={historyOpen ? onCloseHistory : onOpenHistory}
          >
            {historyOpen ? "Hide history" : "Show history"}
          </Button>
        </Stack>
      </Stack>
      {historyOpen && (
        <SupplierShipmentStatusHistoryTable shipment={shipment} />
      )}
    </Stack>
  );
}
